import Upload from './upload';
import Captcha from './captcha';
import DateMask from '../../../../../assets/js/shared/date-mask';
import './chunked-upload';

export default class Form {
    constructor($form) {
        this.$errors = $form.querySelectorAll('.form__error:not(.d-none)');
        $form.querySelectorAll('[data-upload]').forEach($el => (new Upload($el, $form)));
        $form.querySelectorAll('[data-recaptcha]').forEach($el => (new Captcha($el, $form)));
        $form.querySelectorAll('[data-date-mask]').forEach($el => (new DateMask($el)));

        this.checkErrors = this.checkErrors.bind(this);

        window.addEventListener("load", this.checkErrors());
    }

    checkErrors() {
        // if we have errors we scroll to the form
        if(this.$errors.length) {
            // scroll to the first error
            const scrollTo = this.$errors[0].getBoundingClientRect().top;

            window.scrollTo({
                top: scrollTo,
                behavior: "instant"
            });
        }
    }
}
